import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" id=\"search\">\n  <path d=\"M22.992 22.834l-3.387-4.844c1.791-1.768 2.903-4.222 2.903-6.938 0-5.385-4.365-9.75-9.75-9.75s-9.75 4.365-9.75 9.75 4.366 9.75 9.75 9.75c1.499 0 2.913-.348 4.181-.952l3.39 4.848 2.663-1.864zM4.633 11.052c0-4.48 3.645-8.125 8.125-8.125 4.481 0 8.125 3.645 8.125 8.125s-3.644 8.125-8.125 8.125c-4.48 0-8.125-3.645-8.125-8.125z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol